import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { goldBtn } from '../ui';
import { api, eur, errMsg } from '../api';
import { STATUS } from './RequestsList';

export default function ConsPicker({ req, price, onDone }) {
  const [sel, setSel] = useState([]);
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const free = (c) => ['available', 'error'].includes(c.status);
  const toggle = (code) => { setConfirm(false); setSel(sel.includes(code) ? sel.filter((x) => x !== code) : [...sel, code]); };
  const total = (price || 0) * sel.length;
  const order = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/property/mortgage/${req.id}/conservatorie`, { codes: sel });
      if (r.data.warning) toast.warning(r.data.warning); else toast.success('Elenchi sintetici richiesti');
      setSel([]); setConfirm(false); onDone();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-4" data-testid={`mortgage-cons-${req.id}`}>
      <p className="text-[11px] uppercase tracking-[0.18em] text-[#5A5F67] mb-2">Conservatorie con formalità</p>
      <div className="grid sm:grid-cols-2 gap-2">
        {req.conservatorie.map((c) => {
          const [label, cls] = STATUS[c.status] || ['Da aprire', 'text-[#8A8F97] border-[#1F242C]'];
          return (
            <label key={c.code} className={`flex items-center gap-3 border border-[#1F242C] rounded-sm px-3 py-2 ${free(c) ? 'cursor-pointer hover:border-[#5A4A17]' : ''}`} data-testid={`mortgage-cons-item-${c.code}`}>
              {free(c) && <input type="checkbox" className="accent-[#D4AF37]" checked={sel.includes(c.code)} onChange={() => toggle(c.code)} data-testid={`mortgage-cons-check-${c.code}`} />}
              <span className="flex-1 min-w-0"><span className="block text-sm text-[#F2F2F2] truncate">{c.name}</span>{c.info && <span className="block text-xs text-[#5A5F67] truncate">{c.info}</span>}</span>
              {c.status !== 'available' && <span className={`text-[10px] font-mono uppercase px-2 py-0.5 border rounded-sm ${cls}`}>{label}</span>}
            </label>
          );
        })}
      </div>
      {sel.length > 0 && (
        <button onClick={() => (confirm || !price ? order() : setConfirm(true))} disabled={busy} className={`${goldBtn} h-10 px-4 mt-3 inline-flex items-center gap-2 text-sm`} data-testid={`mortgage-cons-order-${req.id}`}>
          {busy && <Loader2 size={14} className="animate-spin" />}
          {!price ? `Apri elenco sintetico (${sel.length}) · incluso` : confirm ? `Conferma addebito ${eur(total)}` : `Apri elenco sintetico · ${sel.length} × ${eur(price)}`}
        </button>
      )}
    </div>
  );
}
